import { Box, Avatar, Typography, MenuItem, IconButton, Menu, Tooltip, useTheme } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import React, { useState } from 'react';
import { useAuth } from '../../auth/context/AuthContext';
import { useThemeMode } from '../../../shared/context/ThemeModeContext';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import { Clock } from './Clock';
import { PanicButton } from '../../../shared/components/PanicButton';
import { splitUserName } from '../../../shared/utils/username';
import { useNavigate } from 'react-router-dom';
import { ROLES } from '../../../shared/constants/roles';

const Header = () => {
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { mode, toggleMode } = useThemeMode();
  const theme = useTheme();
  const navigate = useNavigate();

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => setAnchorEl(null);

  const handleSettingsClick = () => {
    handleMenuClose();
    navigate('/settings');
  };

  const isManager = user?.role?.toLowerCase() === ROLES.GESTOR.toLowerCase();

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      bgcolor={theme.palette.background.paper}
      px={{ xs: 1, md: 3 }}
      py={2}
      boxShadow={1}
      sx={{ flexWrap: 'wrap', gap: 1 }}
    >
      <Box />
      <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
        <PanicButton />
        <Clock />
        <Tooltip title={mode === 'light' ? 'Modo Escuro' : 'Modo Claro'}>
          <IconButton onClick={toggleMode} color="primary">
            {mode === 'light' ? <DarkModeIcon /> : <LightModeIcon />}
          </IconButton>
        </Tooltip>
        <IconButton onClick={handleMenuOpen}>
          <Avatar sx={{ width: 36, height: 36 }} >
            {`${splitUserName(user?.name).firstName}${splitUserName(user?.name).lastName}`}
          </Avatar>
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MenuItem disabled>
            <Typography fontWeight={600}>{user?.name}</Typography>
          </MenuItem>
            <MenuItem onClick={handleSettingsClick}>
              <SettingsIcon fontSize="small" sx={{ mr: 1 }} />
              Configuração da Empresa
            </MenuItem>
          <MenuItem onClick={() => { logout(); handleMenuClose(); }}>
            <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
            Sair
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
};

export default Header;